import http from '@amit/composables/src/useHttp';
import { useApi } from '@amit/composables';

type GenerateImagePayload = {
  prompt: string;
  size: string;
  style: string;
};

export const generateImage = ({
  prompt,
  size,
  style,
}: GenerateImagePayload) => {
  return useApi(http.post('/llm/images', { prompt, size, style }));
};
